module.exports = __webpack_public_path__ + "static/img/w_08.c28ab7e2.jpg";